import styled from "styled-components";

export const Wrapper = styled.div`
  animation: 0.3s ease-out 0s 1 slideIn;

  h4 {
    padding: 0 35px;
  }

  @keyframes slideIn {
    0% {
      transform: translateY(30px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  h1,
  h2,
  h3,
  h4,
  p {
    font-family: "Open Sans Condensed" !important;
  }
`;

export const Domain = styled.div`
  position: relative;
  margin-bottom: 40px;

  .header {
    position: absolute;
    top: -13px;
    right: 35px;

    h4 {
      margin: 0;
      padding: 0;
      display: inline-block;
      text-align: center;
    }
  }

  .question-prefix {
    margin-top: -16px;
    padding-left: 35px;
  }

  @media print {
    margin-top: 30px;

    h4 {
      margin-bottom: 13px;
    }

    p {
      margin-bottom: 12px;
    }
  }
`;

export const Question = styled.div`
  padding-left: 35px;
  position: relative;

  p {
    width: 425px;
    font-size: 13px;
  }

  .data {
    position: absolute;
    top: 0;
    right: 90px;
    line-height: 0;

    .percent {
      position: absolute;
      top: 0;
      right: 210px;
      line-height: 20px;

      &.make-room {
        right: 243px;
      }
    }

    .percent-change {
      position: absolute;
      top: 0;
      right: 215px;
      font-size: 12px;
      line-height: 22px;
      white-space: nowrap;

      &.positive,
      &.negative {
        right: 206px;
      }

      &.positive {
        color: ${props => props.theme.positive};
      }

      &.negative {
        color: ${props => props.theme.negative};
      }
    }

    .percentile {
      position: absolute;
      top: 0;
      right: -55px;
      width: 55px;
      line-height: 20px;
      text-align: center;
    }
  }
`;

export const Bar = styled.div`
  display: inline-block;
  height: 19px;
  background: ${props => props.theme.primary};
  font-weight: bold;
  position: relative;

  .value {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 10px;
    font-size: 10px;

    @media print {
      top: 13px;
    }
  }

  &:hover {
    &:before,
    &:after {
      background: ${props => props.theme.primary};
      border-color: #fff;
      color: #fff;
    }
  }

  &:before {
    box-shadow: 1px 1px 0 0 #fff;
  }

  &.positive,
  &.positive:before,
  &.positive:after {
    background: ${props => props.theme.positive};
  }

  &.neutral,
  &.neutral:before,
  &.neutral:after {
    background: ${props => props.theme.neutral};
  }

  &.negative,
  &.negative:before,
  &.negative:after {
    background: ${props => props.theme.negative};
  }

  &.gray {
    background: #f7f7f7;
  }
`;

export const BigButton = styled.div`
  position: relative;
  width: 219mm;
  margin: 0 auto 25px auto;
  text-align: center;
  background: ${props => props.theme.primary};
  color: #fff;
  padding: 20px;
  border-radius: 5px;
  animation: 0.3s ease-out 0s 1 fadeIn;

  &:hover {
    cursor: pointer;
    background: ${props => props.theme.primaryDark};
  }

  @media print {
    display: none;
  }

  @keyframes fadeIn {
    0% {
      transform: translateY(5px);
      opacity: 0.5;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  img {
    position: absolute;
    right: -177px;
    top: -62px;
    width: 150px;
    transform: rotate(9deg);
    user-select: none;
    pointer-events: none;
  }
`;

export const ProgressWrap = styled.div`
  margin: 100px auto;
  width: 600px;
`;

export const SectionActions = styled.div`
  position: absolute;
  left: calc(100% + 20px);

  button.ui.button {
    width: 200px;
    text-align: left;
    margin-bottom: 7px;
  }

  @media print {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Questions/style.js